module.exports = __webpack_public_path__ + "img/telegram.3a1e658d.png";